import gql from 'graphql-tag'

export function generate_SUBSCRIBE_SUPPORTS_BY_STATUS_AND_PARTNER(name, gqlstr) {
  return  gql`
  subscription ${name}_support($status:[uuid!], $filter: String!, $partnerId: uuid!){
    ${name}: Supports(where:{ status: {_in: $status}, ${gqlstr} _or: [{serialNo: {_ilike: $filter}},{title: {_ilike: $filter}},{AssignTo: {name: {_ilike: $filter}}},
                {Customer: {name:{_ilike: $filter}}},{SupportPlan: {name: {_ilike: $filter}}},{Product: {name: {_ilike: $filter}}}]},
                 order_by: {created_at: desc}){
      id
      title
      level
      priority
      supportNo
      AssignTo { id name }
      Status { id name }
      Product { id name }
      Customer { id name }
      SupportPlan { id name }
      serialNo
      isSupportPlanActive
      created_at
    }
  }
`
}
export const SUBSCRIBE_SUPPORT_ID = gql`
  subscription($id: uuid!){
    Supports(where:{ id: {_eq: $id}}){
      id
      title
      level
      priority
      supportNo
      AssignTo { id name }
      Status { id name }
      Source { id name }
      Product { id name ProductLine {id name} OEM {id name}}
      Customer { id name mobile email companyName companyPhone:phone companyCity:city companyState:state }
      OrderItem {
        id 
        FromOrganization{ id name partnerCode Users{id name mobile email} }
      }      
      SupportPlan { id name }
      CreatedBy {id name }
      Category {id name }
      serialNo
      reference
      retailSalesId
      isSupportPlanActive
      note
      solution
      created_at
    }
  }
`

export const SUBSCRIBE_SUPPORT_HISTORY = gql`
subscription SupportHistory($supportId: uuid!){
 SupportHistory(where: {supportId: {_eq: $supportId}},order_by: {created_at: desc}){      
      id
      supportId
      oldObject
      newObject
      difference
      eventType
      createdByUserName
      updatedByUserName
      createdOn: created_at
      updatedOn: updated_at
 }
}
`
